import { Pipe, PipeTransform, inject } from '@angular/core';
import { DateTime } from 'luxon';
import { TimezoneService } from 'app/shared/services/timezone.service';

@Pipe({
    name: 'timezoneDate',
    standalone: true,
    pure: false // Garante atualização reativa se o fuso no TimezoneService mudar em tempo real
})
export class TimezoneDatePipe implements PipeTransform {
    private timezoneService = inject(TimezoneService);

    transform(value: any, format: string = 'dd/MM/yyyy HH:mm:ss'): string {
        if (!value) return '';

        let date: DateTime;
        if (value instanceof Date) {
            date = DateTime.fromJSDate(value);
        } else if (typeof value === 'string') {
            if (value.includes('T') && value.includes('Z')) {
                date = DateTime.fromISO(value);
            } else {
                date = DateTime.fromISO(value);
            }
        } else if (typeof value === 'number') {
            date = DateTime.fromMillis(value);
        } else {
            return '';
        }

        if (!date.isValid) return '';

        const tz = this.timezoneService.getTimezone();
        // Converte o token do Angular DatePipe (dd/MM/yyyy HH:mm:ss) para os equivalentes do Luxon se necessário
        const resolvedFormat = format
            .replace(/d/g, 'd')
            .replace(/M/g, 'M')
            .replace(/y/g, 'y')
            .replace(/H/g, 'H')
            .replace(/m/g, 'm')
            .replace(/s/g, 's');

        return date.setZone(tz).toFormat(resolvedFormat);
    }
}
